export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_SELECTED_PRODUCT = "SET_SELECTED_PRODUCT";
